import {Module} from '../../../../IoC/Module';
import {CromSolvingStore} from '../stores/CromSolving.store';
import {cromsFeatureContainerFactoryJrpc} from './container.factory.jrpc';

const CROM_SOLVING_FEATURE_KEY = 'cromSolving';

export const coachCromsModule = new Module(
  CROM_SOLVING_FEATURE_KEY,
  cromsFeatureContainerFactoryJrpc,
  {
    CromSolvingStore,
  },
);
